import ComponentActionPanel from "./componentActionPanel.container";

export default ComponentActionPanel;
